export default function HomeHero() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20soft%20ambient%20lighting%2C%20dramatic%20atmosphere%2C%20elegant%20golden%20accents%2C%20empty%20stage%20with%20spotlight%2C%20rich%20dark%20tones%2C%20luxurious%20classic%20cinema%20aesthetic%2C%20deep%20shadows%2C%20theater%20seats%20in%20dark%20red%2C%20artistic%20composition%2C%20no%20text%2C%20no%20people&width=1800&height=900&seq=hero-bg-cinema-01&orientation=landscape"
        alt="黄瓜影院 - 海量高清影视资源"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          海量高清影视资源
          <br />
          <span className="text-accent-400">免费在线观看</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 mb-8 max-w-[650px] mx-auto leading-relaxed">
          黄瓜影院收录最新最热门电影、电视剧、综艺、动漫，支持多线路流畅播放，无需注册即可享受极致观影体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="/category/movie"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-lg"></i>
            开始观影
          </a>
          <a
            href="/about"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white/15 hover:bg-white/25 text-white rounded-full transition-all duration-300 text-sm whitespace-nowrap backdrop-blur-sm cursor-pointer"
          >
            <i className="ri-information-line text-lg"></i>
            了解更多
          </a>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white font-heading">5000+</p>
            <p className="text-xs text-white/60 mt-1">高清影片</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white font-heading">100万+</p>
            <p className="text-xs text-white/60 mt-1">日活用户</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white font-heading">4K</p>
            <p className="text-xs text-white/60 mt-1">超清画质</p>
          </div>
        </div>
      </div>
    </section>
  );
}